import React, { useContext } from "react";
import "./termsOfServiceModal.css";
import { CombinedContext } from "../../../context/combinedContext";
import translations from "../../../translations/translations";
import useModalDismiss from "../useModalDismiss";

const COMPANY_NAME = "Sin Fila";
const CONTACT_EMAIL = "legal@reservasinfila.com";
const LAST_UPDATED = "October 14, 2025";

/* Render p1, p2, p3... safely */
const renderParagraphs = (section) =>
	Object.keys(section || {})
		.filter((k) => k.startsWith("p"))
		.map((key) => (
			<p key={key}>
				{section[key]
					.replace("{{COMPANY_NAME}}", COMPANY_NAME)
					.replace("{{CONTACT_EMAIL}}", CONTACT_EMAIL)}
			</p>
		));

const TermsOfServiceModal = ({ onClose }) => {
	const dismiss = useModalDismiss(onClose, { dismissOnBackdrop: true });
	const { language } = useContext(CombinedContext);
	const t = translations[language].terms;

	return (
		<div className="sf-terms-overlay" {...dismiss}>
			<div className="sf-terms-modal">
				{/* HEADER */}
				<header className="sf-terms-header">
					<div>
						<h1 className="sf-terms-title">{t.title}</h1>
						<p className="sf-terms-updated">
							{t.lastUpdated}: {LAST_UPDATED}
						</p>
					</div>

					<button className="sf-terms-close" onClick={onClose}>
						✕
					</button>
				</header>

				{/* BODY */}
				<div className="sf-terms-body">
					{/* 1) INTRO */}
					<section className="sf-terms-section">
						<h2>{t.intro.heading}</h2>
						{renderParagraphs(t.intro)}
					</section>

					{/* 2) ELIGIBILITY */}
					<section className="sf-terms-section">
						<h2>{t.eligibility.heading}</h2>
						<ul>
							{t.eligibility.list.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</section>

					{/* 3) ACCOUNTS */}
					<section className="sf-terms-section">
						<h2>{t.accounts.heading}</h2>
						<ul>
							{t.accounts.list.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</section>

					{/* 4) BOOKINGS */}
					<section className="sf-terms-section">
						<h2>{t.bookings.heading}</h2>
						{renderParagraphs(t.bookings)}
					</section>

					{/* 5) PROFESSIONAL RESPONSIBILITIES */}
					<section className="sf-terms-section">
						<h2>{t.proResponsibilities.heading}</h2>
						<ul>
							{t.proResponsibilities.list.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</section>

					{/* 6) ACCEPTABLE USE */}
					<section className="sf-terms-section">
						<h2>{t.acceptableUse.heading}</h2>
						<ul>
							{t.acceptableUse.list.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</section>

					{/* 7) USER CONTENT */}
					<section className="sf-terms-section">
						<h2>{t.userContent.heading}</h2>
						{renderParagraphs(t.userContent)}
					</section>

					{/* 8) INTELLECTUAL PROPERTY */}
					<section className="sf-terms-section">
						<h2>{t.ip.heading}</h2>
						{renderParagraphs(t.ip)}
					</section>

					{/* 9) DISCLAIMER */}
					<section className="sf-terms-section">
						<h2>{t.disclaimer.heading}</h2>
						{renderParagraphs(t.disclaimer)}
					</section>

					{/* 10) LIABILITY */}
					<section className="sf-terms-section">
						<h2>{t.liability.heading}</h2>
						{renderParagraphs(t.liability)}
					</section>

					{/* 11) INDEMNITY */}
					<section className="sf-terms-section">
						<h2>{t.indemnity.heading}</h2>
						<p>{t.indemnity.text}</p>
					</section>

					{/* 12) TERMINATION */}
					<section className="sf-terms-section">
						<h2>{t.termination.heading}</h2>
						<p>{t.termination.text}</p>
					</section>

					{/* 13) PRIVACY */}
					<section className="sf-terms-section">
						<h2>{t.privacy.heading}</h2>
						<p>{t.privacy.text}</p>
					</section>

					{/* 14) GOVERNING LAW */}
					<section className="sf-terms-section">
						<h2>{t.law.heading}</h2>
						<p>{t.law.text}</p>
					</section>

					{/* 15) CHANGES */}
					<section className="sf-terms-section">
						<h2>{t.changes.heading}</h2>
						<p>{t.changes.text}</p>
					</section>

					{/* 16) MISC */}
					<section className="sf-terms-section">
						<h2>{t.misc.heading}</h2>
						<ul>
							{t.misc.list.map((item, i) => (
								<li key={i}>{item}</li>
							))}
						</ul>
					</section>
				</div>

				{/* FOOTER */}
				<footer className="sf-terms-footer">
					<button className="sf-terms-btn ghost" onClick={onClose}>
						{t.close}
					</button>
				</footer>
			</div>
		</div>
	);
};

export default TermsOfServiceModal;
